"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
var _react = _interopRequireWildcard(require("react"));
require("./style.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _login = require("../../../../../consts/login");
var _consts = require("../../../../../consts");
var _valid = require("../../../../../consts/valid");
var _accountNetSdk = require("account-net-sdk");
var _SendVerificationCode = _interopRequireDefault(require("../../../../SendVerificationCode"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Mobile = function Mobile(props) {
  var setIsRealName = props.setIsRealName;
  // 错误提示
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    errTip = _useState2[0],
    setErrTip = _useState2[1];
  // 账号
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    account = _useState4[0],
    setAccount = _useState4[1];
  // 验证码
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    verifyCode = _useState6[0],
    setVerifyCode = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    readOnly = _useState8[0],
    setReadOnly = _useState8[1];
  /**
   * 提交
   */
  var handleSubmit = function handleSubmit() {
    // 校验账号
    var _handleValid = (0, _valid.handleValid)(account.trim(), _valid.CODE_ACCOUNT_RULES),
      accountMsg = _handleValid.msg,
      accountValid = _handleValid.valid;
    if (!accountValid) {
      setErrTip(accountMsg);
      return;
    }
    // 校验验证码
    var _handleValid2 = (0, _valid.handleValid)(verifyCode.trim(), _valid.CODE_RULES),
      codeMsg = _handleValid2.msg,
      codeValid = _handleValid2.valid;
    if (!codeValid) {
      setErrTip(codeMsg);
      return;
    }
    setErrTip('');
    var params = {
      account: account.trim(),
      verifyCode: verifyCode.trim(),
      loginType: _login.LOGIN_TYPE,
      bid: _login.BID_MSG
    };
    (0, _accountNetSdk.SmsLogin)(params).then(function (res) {
      if (!res.success) {
        if (res.data === _login.LOGIN_STATUS.realNameError) {
          //需要实名
          setIsRealName(true);
          return;
        }
        setErrTip(res.message);
        props.onError && props.onError(res);
        return;
      }
      var data = {
        maskAccount: res.data
      };
      props.onOk && props.onOk(_objectSpread(_objectSpread({}, data), {}, {
        type: 'msg'
      }));
    }, function (error) {
      setErrTip(error.message);
    });
  };
  var onValid = function onValid() {
    // 校验账号
    var _handleValid3 = (0, _valid.handleValid)(account.trim(), _valid.CODE_ACCOUNT_RULES),
      msg = _handleValid3.msg,
      valid = _handleValid3.valid;
    if (!valid) {
      setErrTip(msg);
      return false;
    }
    setErrTip('');
    return true;
  };
  var onError = function onError(res) {
    setErrTip(res.message);
  };
  var getClock = function getClock(clock) {
    setReadOnly(0 < clock);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_login_msg_wrap"
  }, errTip !== '' && /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_msg_form_error"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "gy_msg_error_icon"
  }), /*#__PURE__*/_react.default.createElement("span", {
    id: "text_msg_login",
    className: (0, _classnames.default)('error_text', 'gy_msg_error_text')
  }, errTip)), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_msg_form_item"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('gy_msg_form_name_icon', 'gy_msg_form_icon')
  }), /*#__PURE__*/_react.default.createElement(_input.default, {
    className: (0, _classnames.default)('gy_msg_form_input'),
    maxLength: 16,
    value: account,
    onChange: function onChange(e) {
      return setAccount(e.target.value);
    },
    placeholder: "\u8D26\u53F7",
    readOnly: readOnly,
    id: "input_msg_login_account"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_msg_form_code"
  }, /*#__PURE__*/_react.default.createElement(_SendVerificationCode.default, {
    account: account,
    prefix: true,
    className: "gy_login_send_msg_wrap",
    sourceType: _consts.SEND_MSG_SOURCE_TYPE.LOGIN,
    disabled: account.trim().length === 0,
    onValid: onValid,
    vcValue: verifyCode,
    onChangeInput: function onChangeInput(e) {
      return setVerifyCode(e.target.value);
    },
    placeholder: "\u77ED\u4FE1\u9A8C\u8BC1\u7801",
    onError: onError,
    getClock: getClock,
    sendInputId: "input_msg_login_code",
    sendBtnId: "btn_msg_login_code"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_msg_form_submit",
    id: "input_msg_login_submit",
    onClick: handleSubmit
  }));
};
var _default = Mobile;
exports.default = _default;